var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { MenuItemSectionStyleType } from '@gc/global-controls-store';
import { GcHeaderCustomMenuLabel } from './gc-header-custom-menu-label';
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
var layoutPropsColumn = {
    justifyContent: 'start',
    direction: 'column'
};
var layoutPropsRow = {
    direction: 'row',
    wrap: 'wrap'
};
var layoutItemPropsRow = {
    grow: 2
};
var layoutProps = {
    COLUMN: layoutPropsColumn,
    ROW: layoutPropsRow
};
var layoutItemProps = {
    ROW: layoutItemPropsRow
};
export var GcHeaderCustomItemSection = function (_a) {
    var menuItemSection = _a.menuItemSection;
    var _b = menuItemSection || {}, _c = _b.subSections, subSections = _c === void 0 ? [] : _c, _d = _b.style, style = _d === void 0 ? MenuItemSectionStyleType.ROW : _d;
    if (!menuItemSection || subSections.length < 1) {
        return null;
    }
    return (React.createElement(EGDSLayoutFlexItem, { minWidth: "full_width" },
        React.createElement(EGDSLayoutFlex, __assign({}, layoutProps[style]), subSections.map(function (section, sectionId) {
            var labels = (section && section.labels) || [];
            var sectionStyle = (section && section.style) || MenuItemSectionStyleType.ROW;
            var itemProps = style && layoutItemProps[style];
            if (!section || labels.length < 1) {
                return null;
            }
            return (React.createElement(EGDSLayoutFlexItem, __assign({}, itemProps, { key: "section-".concat(sectionId) }),
                React.createElement(EGDSLayoutFlex, __assign({}, layoutProps[sectionStyle], { key: sectionId }), labels.map(function (row, idxRow) {
                    var _a = row || {}, _b = _a.text, text = _b === void 0 ? null : _b, _c = _a.type, type = _c === void 0 ? null : _c, _d = _a.iconName, iconName = _d === void 0 ? null : _d, _e = _a.padding, padding = _e === void 0 ? null : _e;
                    return (text && (React.createElement(EGDSLayoutFlexItem, { key: "subSection-".concat(idxRow) },
                        React.createElement(GcHeaderCustomMenuLabel, { key: idxRow, text: text, type: type, iconName: iconName, padding: padding }))));
                }))));
        }))));
};
GcHeaderCustomItemSection.displayName = 'GcHeaderCustomItemSection';
//# sourceMappingURL=gc-header-custom-menu-item-section.js.map